/*global jQuery, vidible*/
(function ($) {
    'use strict';

    $.fn.topVideoVidible = function (option/*, varArgs*/) {
        var args = Array.prototype.slice.call(arguments, 1);

        return this.each(function () {
            var $element = $(this);
            var ctrl = $element.data('topVideoVidible');

            if (!ctrl) {
                var opts = $.extend({},
                    $.fn.topVideoVidible.defaults,
                    typeof option === 'object' && option
                );

                $element.data('topVideoVidible', (ctrl = new TopVideoVidible(this, opts)));
            }

            if (typeof option === 'string') {
                ctrl[option].apply(ctrl, args);
            }
        });
    };

    $.fn.topVideoVidible.defaults = {
        disablePlay: false,
        disableMute: false,
        onEnded: null,
        onReady: null
    };

    function TopVideoVidible(element, options) {
        this.init(element, options);
    }

    TopVideoVidible.prototype = {
        constructor: TopVideoVidible,

        // Properties
        player: null,
        pending: null,
        playerReady: false,

        // Methods
        /**
         * @private
         * @param {jQuery} element
         * @param {object} options
         */
        init: function (element, options) {
            this.options = options;
            this.$element = $(element);
            this.onEnded = options.onEnded ? [options.onEnded] : [];
            this.onReady = options.onReady ? [options.onReady] : [];
            this.pending = {mute: false, play: false};

            this._onVidibleVideoEnd = this._onVidibleVideoEnd.bind(this);
            this._onVidibleVideoStart = this._onVidibleVideoStart.bind(this);
            this._onVidibleVideoMeta = this._onVidibleVideoMeta.bind(this);
            this._onVidiblePlayerReady = this._onVidiblePlayerReady.bind(this);
        },

        /**
         * Player Will be created from vidible ready.
         * It's IMPORTANT to have this function called from outside or the player won't be hooked
         * @param player
         */
        activate: function(player) {
            this.player = player;
            this.player.addEventListener(vidible.VIDEO_END, this._onVidibleVideoEnd);
            this.player.addEventListener(vidible.VIDEO_START, this._onVidibleVideoStart);
            this.player.addEventListener(vidible.VIDEO_META, this._onVidibleVideoMeta);
            this.player.addEventListener(vidible.PLAYER_READY, this._onVidiblePlayerReady);
        },

        get supportsPlay() {
            return !this.options.disablePlay;
        },

        get supportsMute() {
            return !this.options.disableMute;
        },

        play: function () {
            if (this.supportsPlay) {
                if (this.playerReady) {
                    this.player.play();
                } else {
                    this.pending.play = true;
                }
            } else {
                // Playback is disabled. Let the including module handle this.
                this.pending.play = false;
            }
        },

        mute: function () {
            if (this.playerReady) {
                if (this.supportsMute) {
                    this.player.mute();
                }
            } else {
                this.pending.mute = true;
            }
        },

        unmute: function() {
            if (this.playerReady) {
                if (this.supportsMute && this.isMuted) {
                    this.player.toggleMute();
                }
            } else {
                this.pending.mute = false;
            }
        },

        destroy: function() {
            if (this.player) {
                this.player.removeEventListener(vidible.VIDEO_END, this._onVidibleVideoEnd);
                this.player.removeEventListener(vidible.VIDEO_START, this._onVidibleVideoStart);
                this.player.removeEventListener(vidible.PLAYER_READY, this._onVidiblePlayerReady);
                this.player.removeEventListener(vidible.VIDEO_META, this._onVidibleVideoMeta);
                //this.player.destroy();
                this.player = null;
            }
        },

        get isMuted() {
            return this.player ? this.player.getPlayerInfo().volume === 0 : this.pending.mute;
        },

        /** @return {number} */
        get playerWidth() {
            var player = this.player;
            var playerContainer = player.getPlayerContainer();

            return player ? playerContainer.offsetWidth : 0;
        },

        /** @return {number} */
        get playerHeight() {
            var player = this.player;
            var playerContainer = player.getPlayerContainer();

            return player ? playerContainer.offsetHeight : 0;
        },

        _applyState: function () {
            if (this.pending.mute) {
                this.mute();
            }

           if (this.pending.play) {
               this.play();
            }

            this.pending.play = false;
            this.pending.mute = false;
        },

        /** @private */
        _onVidibleVideoEnd: function () {
            this._notifyEnded();
        },

        /** @private */
        _onVidibleVideoStart: function () {

        },

        _onVidibleVideoMeta: function () {

        },

        /** @private */
        _onVidiblePlayerReady: function () {
            this.playerReady = true;
            this._applyState();
            this._notifyReady();
        },

        /** @private */
        _notifyEnded: function () {
            this.$element.triggerHandler('ended');

            this.onEnded.forEach(function (callback) {
                callback(this);
            });
        },

        /** @private */
        _notifyReady: function () {
            this.onReady.forEach(function (callback) {
                callback(this);
            });
        }
    };
})(jQuery);
